/**
 * Master subject IDS
 */

export const AP_PRE_CALCULUS = 117;
export const AP_BIOLOGY = 6;
export const AP_CHEMISTRY = 7;
export const AP_PHYSICS_1 = 92;
export const AP_PHYSICS_2 = 93;
export const AP_PHYSICS_C_EM = 78;
export const AP_PHYSICS_C_MECHANIC = 29;
export const AP_STATISTIC = 33;
export const AP_CALCULUS_AB = 25;
export const AP_CALCULUS_BC = 26;
export const AP_COMPUTER_SCIENCE_PRINCIPLES = 103;
export const AP_COMPUTER_SCIENCE_A = 8;
export const AP_MACROECONOMICS = 10;
export const AP_MICROECONOMICS = 11;

export const MathematicsSubjects = [
  AP_CALCULUS_AB,
  AP_CALCULUS_BC,
  AP_STATISTIC,
  AP_CHEMISTRY,
  AP_BIOLOGY,
  AP_PHYSICS_1,
  AP_PHYSICS_2,
  AP_PHYSICS_C_MECHANIC,
  AP_PHYSICS_C_EM,
  AP_PRE_CALCULUS,
];

export const ReferenceSheetVisibleSubjects = [AP_COMPUTER_SCIENCE_PRINCIPLES];

export const ReferenceSheetComingSoonSubjects = [
  AP_COMPUTER_SCIENCE_A,
  AP_BIOLOGY,
  AP_CHEMISTRY,
  AP_PHYSICS_1,
  AP_PHYSICS_2,
  AP_PHYSICS_C_EM,
  AP_PHYSICS_C_MECHANIC,
  AP_STATISTIC,
];

export const HYBRID_COURSES_SUBJECTS = [
  AP_BIOLOGY,
  AP_CALCULUS_AB,
  AP_CALCULUS_BC,
  AP_MACROECONOMICS,
  AP_MICROECONOMICS,
  AP_CHEMISTRY,
  AP_PHYSICS_1,
  AP_PHYSICS_2,
  AP_PHYSICS_C_EM,
  AP_PHYSICS_C_MECHANIC,
  AP_PRE_CALCULUS,
  AP_STATISTIC,
];

export const HighlightsNotesHiddenSubjects = [
  AP_BIOLOGY,
  AP_CALCULUS_AB,
  AP_CALCULUS_BC,
  AP_CHEMISTRY,
  AP_MACROECONOMICS,
  AP_MICROECONOMICS,
  AP_PHYSICS_1,
  AP_PHYSICS_2,
  AP_PHYSICS_C_EM,
  AP_PHYSICS_C_MECHANIC,
  AP_PRE_CALCULUS,
  AP_STATISTIC,
];
